if (!customElements.get('card-media-slider')) {
  customElements.define(
    'card-media-slider',
    class CardMediaSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.card-media-slider__track');
        this.slides = this.track ? Array.from(this.track.children) : [];
        this.dots = Array.from(this.querySelectorAll('.card-media-slider__dot'));
        this.prevButton = this.querySelector('.card-media-slider__arrow--prev');
        this.nextButton = this.querySelector('.card-media-slider__arrow--next');
        if (!this.track || this.slides.length < 2) return;

        this.currentIndex = 0;
        this.ticking = false;

        this.onScroll = this.onScroll.bind(this);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });

        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', (event) => {
            this.stop(event);
            this.goTo(index);
          });
        });
        this.prevButton?.addEventListener('click', (event) => {
          this.stop(event);
          this.goTo(this.currentIndex - 1);
        });
        this.nextButton?.addEventListener('click', (event) => {
          this.stop(event);
          this.goTo(this.currentIndex + 1);
        });

        this.update();
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.onScroll);
      }

      stop(event) {
        event.preventDefault();
        event.stopPropagation();
      }

      goTo(index) {
        const target = Math.max(0, Math.min(index, this.slides.length - 1));
        this.track.scrollTo({ left: target * this.track.clientWidth, behavior: 'smooth' });
      }

      onScroll() {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.ticking = false;
          this.update();
        });
      }

      update() {
        const width = this.track.clientWidth || 1;
        this.currentIndex = Math.round(this.track.scrollLeft / width);

        this.dots.forEach((dot, index) => {
          const isActive = index === this.currentIndex;
          dot.classList.toggle('is-active', isActive);
          if (isActive) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });

        if (this.prevButton) this.prevButton.disabled = this.currentIndex === 0;
        if (this.nextButton) this.nextButton.disabled = this.currentIndex >= this.slides.length - 1;
      }
    }
  );
}
